// Tekstnormalisatie voor matching tussen PDF-omschrijvingen en prijslijst-items.
const STOPWORDS = new Set([
  'van', 'de', 'het', 'een', 'voor', 'met', 'en', 'in', 'op', 'aan',
  'bij', 'door', 'naar', 'tot', 'uit', 'om', 'als', 'of', 'is', 'zijn',
]);

const REPLACEMENTS: Array<[RegExp, string]> = [
  [/m\s*²/gi, 'm2'],
  [/\bm2\b/gi, 'm2'],
  [/\blm\b/gi, 'lm'],
  [/\bstuk(s)?\b/gi, 'stuk'],
  [/\bst\b/gi, 'stuk'],
  [/\bin?cl(\.|usief)?\b/gi, 'incl'],
  [/\bexcl(\.|usief)?\b/gi, 'excl'],
  // Nederlandse synoniemen
  [/\bplaatsing\b/gi, 'plaatsen'],
  [/\bafbreken\b/gi, 'afbraak'],
  [/\bafbreek\b/gi, 'afbraak'],
  [/\bvervanging\b/gi, 'vervangen'],
  [/\bverwijdering\b/gi, 'verwijderen'],
  [/\bherplaatsing\b/gi, 'herplaatsen'],
  [/\+/g, ' en '],
  [/[()\[\]]/g, ' '],
  [/[/-]/g, ' '],
  [/[.,;:]/g, ' '],
];

export function normalizeText(s: string | null | undefined): string {
  if (!s) return '';
  let t = String(s).toLowerCase();
  t = t.normalize('NFD').replace(/[̀-ͯ]/g, '');
  for (const [re, rep] of REPLACEMENTS) t = t.replace(re, rep);
  t = t.replace(/\s+/g, ' ').trim();
  return t;
}

export function normalizeTokens(s: string | null | undefined): string[] {
  return normalizeText(s).split(' ').filter((t) => t && !STOPWORDS.has(t));
}

export function normalizeEenheid(e: string | null | undefined): string {
  if (!e) return '';
  const u = String(e).toUpperCase().trim().replace('M²', 'M2');
  if (u === 'STUK' || u === 'ST') return 'STUK';
  if (u === 'LM' || u === 'M') return 'LM';
  if (u === 'M2') return 'M2';
  return u;
}
